import type { LocationRecord, LocationSchema } from '@libs/data-access/entities'

import { getShiftDurationAsMinutes } from './getShiftDurationAsMinutes'

export const canSetAutomaticBreaks = (
  location: LocationRecord | LocationSchema,
  shiftTimeRange: string[]
): boolean => {
  const {
    set_default_break_on_shifts,
    minimum_shift_duration_for_automatic_breaks_in_minutes,
    default_break_duration_type
  } = location
  const [start, end] = shiftTimeRange

  if (start === end) {
    return false
  }

  if (default_break_duration_type !== 'minutes') {
    return true
  }

  const shiftDurationInMinutes = getShiftDurationAsMinutes(start, end)

  return (
    set_default_break_on_shifts &&
    shiftDurationInMinutes >=
      minimum_shift_duration_for_automatic_breaks_in_minutes
  )
}
